
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M17.004 14.004v2h-2.441A.52.52 0 0014.5 16h-2.084l-4-4 3.996-3.996h4.592v2a.5.5 0 00.85.35l3.002-3a.51.51 0 000-.71l-3.002-3a.5.5 0 00-.85.36v2H14.56A.506.506 0 0014.5 6H12a1 1 0 00-.706.293L6.586 11H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h6.086l4.708 4.707A1 1 0 0012 18v.004h5.004v2a.5.5 0 00.85.35l3.002-3a.51.51 0 000-.71l-3.002-3a.5.5 0 00-.85.36z"}})])
          )
        }
      }
    